<div class="show-mobile hide-desktop bg-grey-white_smoke dark:bg-contrast-black">
    <div class="w-full bg-white shadow">
        <div class="flex-align-center flex h-16 flex-row justify-center py-4">
            <ion-button
                class="absolute left-0"
                *ngIf="env.IS_MOBILE_APP"
                (click)="handleBackClicked()"
                color="primary"
                fill="clear">
                <ion-icon
                    class="var-app-light:text-primary mr-1 text-xl text-secondary dark:filter-yellow"
                    src="{{ assetsPath$ | async }}/img/journey-planner/icon-arrow.svg">
                </ion-icon>
            </ion-button>
            <h1
                class="var-app-light-dark:font-bold orb-app-light-dark:font-bold text-center text-base font-semibold leading-5">
                {{ 'ACCOUNT_AND_SETTINGS' | translate }}
            </h1>
        </div>
        <hr class="item-separator m-0" />
        <div class="flex-column flex-align-center var-app-light-dark:gap-0 flex justify-center gap-4 p-4 pt-6">
            <rwidget-customer-account-user-avatar
                [useMenuIconAvatar]="
                    env.MOBILE_MENU_CUSTOMIZATION?.USE_MENU_ICON
                "></rwidget-customer-account-user-avatar>
            <p class="orb-app-light-dark:font-semibold text-center font-bold">
                <ng-container *ngIf="(profile$ | async)?.name; else firstLastName">
                    {{ (profile$ | async)?.name }}
                </ng-container>
            </p>
            <ng-template #firstLastName>
                {{ (profile$ | async)?.firstName ?? '' }} {{ (profile$ | async)?.lastName ?? '' }}
            </ng-template>
        </div>
        <!-- This can be extended in the future to include the profile avatar/username section -->
    </div>
    <div class="block-full-width no-padding no-border-radius mt-4 shadow dark:bg-contrast-black">
        <div class="edit-profile-account">
            <h2
                class="var-app-light-dark:font-semibold orb-app-light-dark:font-semibold mb-6 text-xs font-bold uppercase leading-4 tracking-wide text-grey-dark dark:text-contrast-yellow"
                [class.normal-case]="env.REMOVE_UPPERCASE">
                {{ 'MY_ACCOUNT' | translate }}
            </h2>
            <form #accountForm [formGroup]="_customerForm" (ngSubmit)="onSubmit()" ridangoFocusInvalidInput>
                <ng-container *ngIf="(customerFields$ | async).includes('first_name')">
                    <div>
                        <p
                            class="relative inline-block px-2 text-xs text-grey-zambezy dark:bg-contrast-black dark:text-contrast-yellow"
                            *ngIf="!canEdit">
                            {{ 'PH_FIRST_NAME' | translate }}
                        </p>
                        <p
                            class="relative border border-solid border-transparent px-2 py-3 text-base font-normal leading-5"
                            *ngIf="!canEdit">
                            {{ (profile$ | async)?.firstName }}
                        </p>
                        <mat-form-field class="w-full text-base" *ngIf="canEdit" appearance="outline">
                            <mat-label>{{ 'PH_FIRST_NAME' | translate }}</mat-label>
                            <input
                                [required]="profileUpdateOptions?.FIRST_NAME_MANDATORY"
                                [attr.aria-label]="'PH_FIRST_NAME' | translate"
                                [title]="'PH_FIRST_NAME' | translate"
                                formControlName="firstName"
                                matInput
                                type="text"
                                name="first_name" />
                            <mat-error
                                *ngIf="
                                    _customerForm?.get('firstName')?.touched &&
                                    _customerForm?.get('firstName')?.hasError('required')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>
                <ng-container *ngIf="(customerFields$ | async).includes('last_name')">
                    <div>
                        <p
                            class="relative inline-block px-2 text-xs text-grey-zambezy dark:bg-contrast-black dark:text-contrast-yellow"
                            *ngIf="!canEdit">
                            {{ 'PH_LAST_NAME' | translate }}
                        </p>
                        <p
                            class="relative border border-solid border-transparent px-2 py-3 text-base font-normal leading-5"
                            *ngIf="!canEdit">
                            {{ (profile$ | async)?.lastName }}
                        </p>
                        <mat-form-field class="w-full text-base" *ngIf="canEdit" appearance="outline">
                            <mat-label>{{ 'PH_LAST_NAME' | translate }}</mat-label>
                            <input
                                [required]="profileUpdateOptions?.LAST_NAME_MANDATORY"
                                formControlName="lastName"
                                matInput
                                type="text"
                                attr.aria-label="{{ 'PH_LAST_NAME' | translate }}"
                                title="{{ 'PH_LAST_NAME' | translate }}"
                                name="last_name" />
                            <mat-error
                                *ngIf="
                                    _customerForm?.get('lastName')?.touched &&
                                    _customerForm?.get('lastName')?.hasError('required')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>
                <ng-container *ngIf="(customerFields$ | async).includes('phone_number')">
                    <div>
                        <p
                            class="relative inline-block px-2 text-xs text-grey-zambezy dark:bg-contrast-black dark:text-contrast-yellow"
                            *ngIf="!canEdit">
                            {{ 'PH_PHONE_NUMBER' | translate }}
                        </p>
                        <p
                            class="relative border border-solid border-transparent px-2 py-3 text-base font-normal leading-5"
                            *ngIf="!canEdit && (profile$ | async)?.phoneNumber !== null">
                            {{ (profile$ | async)?.countryCode && (profile$ | async)?.phoneNumber ? '+' : ''
                            }}{{ (profile$ | async)?.countryCode }}{{ (profile$ | async)?.phoneNumber }}
                        </p>
                        <mat-form-field class="w-full text-base" *ngIf="canEdit && _customerForm" appearance="outline">
                            <mat-label>{{ 'PH_PHONE_NUMBER' | translate }}</mat-label>

                            <input
                                [required]="profileUpdateOptions?.PHONE_NUMBER_MANDATORY"
                                formControlName="phoneNumber"
                                matInput
                                type="text"
                                attr.aria-label="{{ 'PH_PHONE_NUMBER' | translate }}"
                                title="{{ 'PH_PHONE_NUMBER' | translate }}"
                                name="phone_number" />

                            <mat-error
                                *ngIf="
                                    _customerForm?.get('phoneNumber')?.touched &&
                                    _customerForm?.get('phoneNumber')?.hasError('required')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_REQUIRED' | translate }}
                            </mat-error>

                            <mat-error
                                *ngIf="
                                    _customerForm?.get('phoneNumber')?.touched &&
                                    _customerForm?.get('phoneNumber')?.hasError('phoneTooShort')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_SHORT' | translate }}
                            </mat-error>
                            <mat-error
                                *ngIf="
                                    _customerForm?.get('phoneNumber')?.touched &&
                                    _customerForm?.get('phoneNumber')?.hasError('phoneTooLong')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_LONG' | translate }}
                            </mat-error>
                            <mat-error
                                *ngIf="
                                    _customerForm?.get('phoneNumber')?.touched &&
                                    _customerForm?.get('phoneNumber')?.hasError('invalidPhoneCountryCode')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_INVALID_COUNTRY_CODE' | translate }}
                            </mat-error>
                            <mat-error
                                *ngIf="
                                    _customerForm?.get('phoneNumber')?.touched &&
                                    _customerForm?.get('phoneNumber')?.hasError('invalidPhoneNumber')
                                ">
                                {{ 'LOCAL_INPUT_VALIDATION_PHONE_PATTERN' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </ng-container>
                <ng-container *ngIf="(customerFields$ | async).includes('name')">
                    <div>
                        <p
                            class="relative inline-block px-2 text-xs text-grey-zambezy dark:bg-contrast-black dark:text-contrast-yellow"
                            *ngIf="!canEdit">
                            {{ 'PH_CUSTOMER_NAME' | translate }}
                        </p>
                        <p
                            class="relative border border-solid border-transparent px-2 py-3 text-base font-normal leading-5"
                            *ngIf="!canEdit">
                            {{ (profile$ | async)?.name }}
                        </p>
                        <mat-form-field class="w-full text-base" *ngIf="canEdit" appearance="outline">
                            <mat-label>{{ 'PH_CUSTOMER_NAME' | translate }}</mat-label>
                            <input
                                formControlName="name"
                                matInput
                                type="text"
                                aria-label="{{ 'LOCAL_LABEL_NAME' | translate }}"
                                title="{{ 'LOCAL_LABEL_NAME' | translate }}"
                                name="name"
                                value="{{ (profile$ | async)?.name }}" />
                        </mat-form-field>
                    </div>
                </ng-container>
                <ng-container *ngIf="(customerFields$ | async).includes('email')">
                    <div>
                        <p
                            class="relative pl-2 text-xs text-grey-zambezy dark:text-contrast-yellow"
                            *ngIf="!canEdit || env.IS_MOBILE_APP">
                            {{ 'EMV_YOUR_EMAIL' | translate }}
                        </p>
                        <p
                            class="relative border border-solid border-transparent px-2 py-3 text-base font-normal leading-5"
                            *ngIf="!canEdit || env.IS_MOBILE_APP">
                            {{ (profile$ | async)?.email }}
                        </p>
                        <mat-form-field
                            class="w-full text-base"
                            *ngIf="canEdit && !env.IS_MOBILE_APP"
                            appearance="outline">
                            <mat-label>{{ 'LOCAL_LABEL_EMAIL' | translate }}</mat-label>
                            <input
                                formControlName="email"
                                matInput
                                type="email"
                                aria-label="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
                                title="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
                                name="email"
                                value="{{ (profile$ | async)?.email }}"
                                required />
                        </mat-form-field>
                    </div>
                </ng-container>
                <ng-container *ngIf="(customerFields$ | async).includes('personal_code')">
                    <div>
                        <p
                            class="relative inline-block px-2 text-xs text-grey-zambezy dark:bg-contrast-black dark:text-contrast-yellow">
                            {{ 'PH_PERSONAL_CODE' | translate }}
                        </p>
                        <p
                            class="relative border border-solid border-transparent px-2 py-3 text-base font-normal leading-5">
                            {{ (profile$ | async)?.personalCode }}
                        </p>
                    </div>
                </ng-container>
                <ng-container *ngIf="(customerFields$ | async)?.includes('phone')">
                    <div>
                        <p
                            class="relative inline-block w-fit rounded px-2 text-xs text-grey-zambezy dark:bg-contrast-black dark:text-contrast-yellow"
                            *ngIf="!canEdit"
                            [ngClass]="{
                                'ml-1 bg-[#F0F0F0] !px-1 text-[#E31C3B]':
                                    _customerForm?.get('phone')?.errors?.['phoneTooShort'] ||
                                    _customerForm?.get('phone')?.errors?.['phoneTooLong'] ||
                                    _customerForm?.get('phone')?.errors?.['invalidPhoneCountryCode'] ||
                                    _customerForm?.get('phone')?.errors?.['invalidPhoneNumber']
                            }">
                            {{ 'PH_PHONE_NUMBER' | translate }}
                        </p>

                        <p
                            class="relative border border-solid border-transparent px-2 py-3 text-base font-normal leading-5"
                            *ngIf="!canEdit">
                            {{ getPhoneNumber(profile$ | async) ? contactPhone : (profile$ | async)?.phone }}
                        </p>

                        <mat-form-field class="w-full text-base" *ngIf="canEdit && _customerForm" appearance="outline">
                            <mat-label>{{ 'LOCAL_LABEL_PHONE_NUMBER' | translate }}</mat-label>
                            <!-- Prefer formControlName if the control always exists -->
                            <input
                                [value]="(profile$ | async)?.phone || ''"
                                formControlName="phone"
                                matInput
                                type="text"
                                inputmode="tel"
                                aria-label="{{ 'LOCAL_LABEL_PHONE_NUMBER' | translate }}"
                                title="{{ 'LOCAL_LABEL_PHONE_NUMBER' | translate }}"
                                name="phone" />
                        </mat-form-field>

                        <mat-error
                            *ngIf="
                                _customerForm?.get('phone')?.touched &&
                                _customerForm?.get('phone')?.hasError('phoneTooShort')
                            ">
                            {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_SHORT' | translate }}
                        </mat-error>
                        <mat-error
                            *ngIf="
                                _customerForm?.get('phone')?.touched &&
                                _customerForm?.get('phone')?.hasError('phoneTooLong')
                            ">
                            {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_LONG' | translate }}
                        </mat-error>
                        <mat-error
                            *ngIf="
                                _customerForm?.get('phone')?.touched &&
                                _customerForm?.get('phone')?.hasError('invalidPhoneCountryCode')
                            ">
                            {{ 'LOCAL_INPUT_VALIDATION_PHONE_INVALID_COUNTRY_CODE' | translate }}
                        </mat-error>
                        <mat-error
                            *ngIf="
                                _customerForm?.get('phone')?.touched &&
                                _customerForm?.get('phone')?.hasError('invalidPhoneNumber')
                            ">
                            {{ 'LOCAL_INPUT_VALIDATION_PHONE_PATTERN' | translate }}
                        </mat-error>
                    </div>
                </ng-container>
                <hr class="item-separator mt-4" [class.mb-0]="canEdit" />
                <ng-container class="action-selector" *ngIf="(actions$ | async)?.length && !canEdit">
                    <div class="w-full text-base leading-10">
                        <ul class="mb-2 text-center" role="menu">
                            <li *ngFor="let action of actions$ | async; last as isLast">
                                <button
                                    class="orb-app-light-dark:font-semibold vl-app-light:text-primary var-app-light:text-primary var-app-light-dark:font-semibold flex w-full items-center justify-center font-medium text-secondary dark:!text-contrast-yellow"
                                    #menuItem
                                    *ngIf="
                                        action === 'ACCOUNT_ACTION_DELETE_ACCOUNT' ||
                                        (!isAuthenticatedCustomer && action !== 'ACCOUNT_ACTION_DELETE_ACCOUNT')
                                    "
                                    [ngClass]="{
                                        'orb-app-light:!text-danger !text-red':
                                            action === 'ACCOUNT_ACTION_DELETE_ACCOUNT'
                                    }"
                                    (click)="actionClicked(action, $event)"
                                    role="menuitem"
                                    tabindex="-1">
                                    <mat-icon
                                        class="!h-8 !w-8"
                                        *ngIf="
                                            env.MOBILE_MENU_CUSTOMIZATION?.SHOW_ACTION_BUTTON_ICONS && action
                                                | accountActionIcon as icon
                                        "
                                        [svgIcon]="icon"></mat-icon>
                                    <span>{{ action | translate }}</span>
                                </button>
                                <hr
                                    class="item-separator m-2"
                                    *ngIf="
                                        !isLast &&
                                        (action === 'ACCOUNT_ACTION_DELETE_ACCOUNT' ||
                                            (!isAuthenticatedCustomer && action !== 'ACCOUNT_ACTION_DELETE_ACCOUNT'))
                                    " />
                            </li>
                        </ul>
                    </div>
                </ng-container>
                <ng-container *ngIf="!canEdit">
                    <button
                        class="pn-light:bg-[var(--btn-primary-color)] pn-light:text-white pn-app-light:bg-[var(--btn-primary-color)] pn-app-light:text-white vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black var-app-light:text-black var-app-light-dark:font-semibold orb-app-light:bg-primary orb-app-light:text-black orb-app-light-dark:font-semibold h-14 w-full rounded-lg bg-secondary font-bold text-white dark:bg-contrast-yellow dark:text-contrast-black"
                        (click)="logout()">
                        <ion-label class="text-base font-bold normal-case">
                            {{ 'LOG_OUT' | translate }}
                        </ion-label>
                    </button>
                </ng-container>
                <ng-container *ngIf="!canEdit && shouldShowPersonalizationForAccount">
                    <ion-button
                        class="w-full"
                        *ngIf="!accountPersonalizationState"
                        [attr.aria-label]="'LINK_PERSONAL_CODE' | translate"
                        (click)="handlePersonalizeAccount()"
                        size="large"
                        color="secondary">
                        <ion-label class="text-base font-bold normal-case">
                            {{ 'LINK_PERSONAL_CODE' | translate }}
                        </ion-label>
                    </ion-button>
                    <ng-container *ngIf="accountPersonalizationState">
                        <ion-label class="align-center flex justify-center text-base font-bold normal-case">
                            {{ 'PERSONALIZED_ACCOUNT' | translate }}
                        </ion-label>
                    </ng-container>
                </ng-container>
                <div *ngIf="canEdit">
                    <div class="mx-0 w-full text-base">
                        <button
                            class="var-app-light:text-primary var-app-light-dark:font-semibold vl-app-light:text-primary btn--maximal sr-app-light:h-14 sr-app-light:text-[1rem] flex items-center justify-center gap-2 rounded-lg p-5 py-6 font-medium text-secondary dark:!text-contrast-yellow"
                            (click)="toggleAccountEdit()"
                            type="button">
                            <ion-icon
                                class="text-[2rem] dark:filter-yellow"
                                *ngIf="env?.ACCOUNT?.SHOW_ICON_FOR_ACCOUNT_EDIT_BUTTONS"
                                [src]="(assetsPath$ | async) + '/img/menu/cross.svg'"
                                aria-hidden="true"></ion-icon>
                            {{ 'CANCEL_EDITING' | translate }}
                        </button>
                        <button
                            class="var-app-light:text-black var-app-light-dark:font-semibold orb-app-light:text-black orb-app-light-dark:font-semibold orb-app-light-dark:py-2 btn btn--maximal btn--primary btn--big sr-app-light:h-14 sr-app-light:text-[1rem] mb-4 rounded-lg py-6 font-bold"
                            type="submit">
                            {{ 'SAVE_DETAILS' | translate }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
<div class="show-desktop hide-mobile">
    <div class="block-full-width">
        <h2 class="p-2 text-[44px] leading-[3rem]">{{ 'ACCOUNT_AND_SETTINGS' | translate }}</h2>
        <div class="grid grid-cols-[2fr_1fr] gap-2 p-2">
            <div>
                <div>
                    <h2
                        class="var-app-light:font-normal px-2 pt-4 text-xs font-semibold uppercase leading-4 tracking-wide text-grey-dark dark:text-contrast-yellow">
                        {{ 'MY_ACCOUNT' | translate }}
                    </h2>
                    <form
                        class="h-full py-4"
                        [formGroup]="_customerForm"
                        (ngSubmit)="onSubmit()"
                        ridangoFocusInvalidInput>
                        <ng-container *ngIf="(customerFields$ | async).includes('name')">
                            <div class="w-full">
                                <p class="relative top-1.5 pl-2 text-xs text-grey-zambezy dark:text-contrast-yellow">
                                    {{ 'PH_CUSTOMER_NAME' | translate }}
                                </p>
                                <p
                                    class="relative bottom-1 border border-solid border-transparent px-2 py-3 text-base font-normal leading-5"
                                    *ngIf="!canEdit">
                                    {{ (profile$ | async)?.name }}
                                </p>
                                <ion-input
                                    class="stw-form bottom-1 rounded-lg text-base"
                                    *ngIf="canEdit && _customerForm"
                                    [value]="(profile$ | async)?.name || ''"
                                    formControlName="name"
                                    aria-label="{{ 'LOCAL_LABEL_NAME' | translate }}"
                                    title="{{ 'LOCAL_LABEL_NAME' | translate }}"
                                    name="name"
                                    type="text">
                                </ion-input>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="(customerFields$ | async).includes('email')">
                            <div class="w-full">
                                <p
                                    class="relative top-1.5 inline-block px-2 text-xs text-grey-zambezy dark:bg-contrast-black dark:text-contrast-yellow">
                                    {{ 'EMV_YOUR_EMAIL' | translate }}
                                </p>
                                <p
                                    class="relative bottom-1 border border-solid border-transparent px-2 py-3 text-base font-normal leading-5"
                                    *ngIf="!canEdit">
                                    {{ (profile$ | async)?.email }}
                                </p>
                                <ion-input
                                    class="stw-form bottom-1 rounded-lg text-base"
                                    *ngIf="canEdit"
                                    value="{{ (profile$ | async)?.email }}"
                                    name="email"
                                    type="email"
                                    aria-label="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
                                    title="{{ 'LOCAL_LABEL_EMAIL' | translate }}"
                                    required
                                    disabled>
                                </ion-input>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="(customerFields$ | async)?.includes('phone')">
                            <div class="w-full">
                                <p class="relative top-1.5 pl-2 text-xs text-grey-zambezy dark:text-contrast-yellow">
                                    {{ 'PH_PHONE_NUMBER' | translate }}
                                </p>

                                <p
                                    class="relative bottom-1 border border-solid border-transparent px-2 py-3 text-base font-normal leading-5"
                                    *ngIf="!canEdit">
                                    {{ getPhoneNumber(profile$ | async) ? contactPhone : (profile$ | async)?.phone }}
                                </p>

                                <ion-input
                                    class="stw-form bottom-1 rounded-lg text-base"
                                    *ngIf="canEdit && _customerForm"
                                    [value]="(profile$ | async)?.phone || ''"
                                    formControlName="phone"
                                    aria-label="{{ 'LOCAL_LABEL_PHONE_NUMBER' | translate }}"
                                    title="{{ 'LOCAL_LABEL_PHONE_NUMBER' | translate }}"
                                    name="phone"
                                    type="tel"
                                    inputmode="tel">
                                </ion-input>

                                <ridango-error
                                    *ngIf="
                                        _customerForm?.get('phone')?.touched &&
                                        _customerForm?.get('phone')?.hasError('phoneTooShort')
                                    ">
                                    {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_SHORT' | translate }}
                                </ridango-error>
                                <ridango-error
                                    *ngIf="
                                        _customerForm?.get('phone')?.touched &&
                                        _customerForm?.get('phone')?.hasError('phoneTooLong')
                                    ">
                                    {{ 'LOCAL_INPUT_VALIDATION_PHONE_TOO_LONG' | translate }}
                                </ridango-error>
                                <ridango-error
                                    *ngIf="
                                        _customerForm?.get('phone')?.touched &&
                                        _customerForm?.get('phone')?.hasError('invalidPhoneCountryCode')
                                    ">
                                    {{ 'LOCAL_INPUT_VALIDATION_PHONE_INVALID_COUNTRY_CODE' | translate }}
                                </ridango-error>
                                <ridango-error
                                    *ngIf="
                                        _customerForm?.get('phone')?.touched &&
                                        _customerForm?.get('phone')?.hasError('invalidPhoneNumber')
                                    ">
                                    {{ 'LOCAL_INPUT_VALIDATION_PHONE_PATTERN' | translate }}
                                </ridango-error>
                            </div>
                        </ng-container>
                    </form>
                </div>
            </div>
            <div>
                <ng-container *ngIf="(actions$ | async)?.length && !canEdit">
                    <div class="flex w-full flex-col gap-2 text-base leading-10">
                        <ul role="menu">
                            <li *ngFor="let action of actions$ | async" role="menuitem">
                                <button
                                    class="var-app-light:text-primary dark:!text-contrast-yellow"
                                    #menuItem
                                    *ngIf="
                                        action === 'ACCOUNT_ACTION_DELETE_ACCOUNT' ||
                                        (!isAuthenticatedCustomer && action !== 'ACCOUNT_ACTION_DELETE_ACCOUNT')
                                    "
                                    [ngClass]="{ delete_user: action === 'ACCOUNT_ACTION_DELETE_ACCOUNT' }"
                                    (click)="actionClicked(action, $event)"
                                    (keydown)="actionClicked(action, $event)"
                                    role="button"
                                    tabindex="-1">
                                    <mat-icon
                                        class="mb-1 inline-block !h-8 !w-8 align-middle"
                                        *ngIf="
                                            env.MOBILE_MENU_CUSTOMIZATION?.SHOW_ACTION_BUTTON_ICONS && action
                                                | accountActionIcon as icon
                                        "
                                        [svgIcon]="icon"></mat-icon>
                                    {{ action | translate }}
                                </button>
                                <hr class="item-separator" *ngIf="!isAuthenticatedCustomer" />
                            </li>
                        </ul>
                        <ng-container *ngIf="!canEdit">
                            <ion-button
                                class="w-full"
                                [attr.aria-label]="'LOG_OUT' | translate"
                                (click)="logout()"
                                size="large"
                                color="secondary">
                                <ion-label class="text-base font-bold normal-case">
                                    {{ 'LOG_OUT' | translate }}
                                </ion-label>
                            </ion-button>
                        </ng-container>
                        <ng-container *ngIf="!canEdit && shouldShowPersonalizationForAccount">
                            <ion-button
                                class="w-full"
                                *ngIf="!accountPersonalizationState"
                                [attr.aria-label]="'LINK_PERSONAL_CODE' | translate"
                                (click)="handlePersonalizeAccount()"
                                size="large"
                                color="secondary">
                                <ion-label class="text-base font-bold normal-case">
                                    {{ 'LINK_PERSONAL_CODE' | translate }}
                                </ion-label>
                            </ion-button>
                            <ng-container *ngIf="accountPersonalizationState">
                                <ion-label class="align-center text-base font-bold normal-case">
                                    {{ 'PERSONALIZED_ACCOUNT' | translate }}
                                </ion-label>
                            </ng-container>
                        </ng-container>
                    </div>
                </ng-container>
                <div class="my-2 w-full" *ngIf="canEdit">
                    <div class="flex w-full flex-col gap-2">
                        <ion-button
                            class="w-full"
                            [attr.aria-label]="'SAVE_DETAILS' | translate"
                            (click)="onSubmit()"
                            size="large"
                            color="secondary">
                            <ion-label class="text-base font-bold normal-case">
                                {{ 'SAVE_DETAILS' | translate }}
                            </ion-label>
                        </ion-button>
                        <ion-button
                            class="w-full"
                            [attr.aria-label]="'CANCEL' | translate"
                            (click)="toggleAccountEdit()"
                            size="large"
                            color="secondary">
                            <ion-label class="text-base font-bold normal-case">
                                {{ 'CANCEL' | translate }}
                            </ion-label>
                        </ion-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template #deleteConfirmation>
        <rwidget-customer-account-delete [deleteModalReference]="deleteConfirmationModal">
        </rwidget-customer-account-delete>
    </ng-template>
</div>
